import { Component, Input, OnInit } from '@angular/core';
import { PgFormField } from '../../models/form.model';
import { EnvironmentService } from '../../services/environment.service';
import { PGUtilities } from '../../utilities/pg-utilities';
import { LocalizationService } from '../../services/localization.service';

@Component({
    selector: 'app-pg-detail-field',
    templateUrl: './pg-detail-field.component.html',
    styleUrls: ['./pg-detail-field.component.scss'],
    standalone: false
})

export class PgDetailFieldComponent implements OnInit {

    constructor(private environmentService:EnvironmentService, private localizationService:LocalizationService) {}
    
    @Input() fieldData: PgFormField;

    @Input() value:any;
    @Input() languages:string|Array<string>;
    @Input() currency:string;

    @Input() placeholder:string;

    cleanValue:any

    ngOnInit(): void {
    }

    ngOnChanges() {
        this.cleanValue = this.value;

        if(this.fieldData) {
            if(this.fieldData.type == 'select') {
                if(this.fieldData.resource != null) {
                    
                }
            }
            else if(this.fieldData.locale && !this.localizationService.format.hasTypeInternalLanguageHandling(this.fieldData.type)) {
                let _languages:Array<string> = null;
    
                if(typeof this.languages == 'string') {
                    _languages = PGUtilities.tryParseJSON(this.languages)
                }
                else {
                    _languages = this.languages;
                }
    
                if(_languages != null) {
                    let _valueByLanguage = this.value;
                    if(typeof _valueByLanguage == 'string') _valueByLanguage = PGUtilities.tryParseJSON(_valueByLanguage)
    
                    if(_valueByLanguage != null) {
                        this.cleanValue = {};
    
                        for(let i of _languages) {
                            this.cleanValue[i] = _valueByLanguage[i]
                        }
    
                        this.cleanValue = JSON.stringify(this.cleanValue)
                    }
                }
            }
        }
    }

    getExtraParam() {
        if(this.fieldData.type == 'price' || this.fieldData.type == 'tickets-experience' || this.fieldData.type == 'tickets-host') return this.currency || this.environmentService.getDefaultCurrency();
    }
}
